const awsmobile = {
  "aws_project_region": "us-east-1",
  "aws_cognito_region": "us-east-1",
  "aws_user_pools_id": "us-east-1_ONpMGlrNX",
  "aws_user_pools_web_client_id": "2romraj0opclhlsmjku0hiu9j4",
  "oauth": {
    "domain": "auth.revfer.com",
    "scope": ["email", "openid", "profile"],
    "redirectSignIn": "https://www.revfer.com/",
    "redirectSignOut": "https://www.revfer.com",
    "responseType": "code"
  }
};
export default awsmobile;
